const { REACT_APP_AUTH_KEY_ID } = process.env;

export const AuthTokenKey = REACT_APP_AUTH_KEY_ID || "AuthToken";